import { useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "react-query";

const fetchCategory = async (key, categoryId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/${categoryId}`
  );
};

export default function CategoriesPage() {
  const { categoryId } = useParams();
  const { data, error, isLoading } = useQuery(
    ["category", categoryId],
    fetchCategory
  );

  if (isLoading) return <h1>Loading...</h1>;

  return (
    <div>
      <h1>{data.data.data.category.name}</h1>
    </div>
  );
}
